import { render, staticRenderFns } from "./CancelledBidInfo.vue?vue&type=template&id=413ce32e"
import script from "./CancelledBidInfo.vue?vue&type=script&lang=js"
export * from "./CancelledBidInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports